<template>
  <div id="mechanism">
    <div class="table-section">
      <el-card class="box-card" shadow="never">
        <el-form
          :inline="true"
          :model="searchParams"
          class="demo-form-inline"
          
        >
          <el-form-item label="业务类型">
            <el-select
              v-model.trim="searchParams.businessType"
              placeholder="业务类型"
            >
              <el-option
                v-for="item in businessTypeList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="产品">
            <el-select v-model.trim="searchParams.product" placeholder="产品">
              <el-option
                v-for="item in productList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="合同编号">
            <el-input
              v-model.trim="searchParams.contractNumber"
              placeholder="合同编号"
            />
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input
              v-model.trim="searchParams.borrowerName"
              placeholder="客户姓名"
            />
          </el-form-item>
          <el-form-item label="手机号码">
            <el-input
              v-model.trim="searchParams.borrowerPhone"
              placeholder="手机号码"
            />
          </el-form-item>
          <el-form-item label="身份证号码">
            <el-input
              v-model.trim="searchParams.idNumber"
              placeholder="身份证号码"
            />
          </el-form-item>
          <el-form-item label="逾期天数">
            <el-input
              v-model.trim="searchParams.overdueDays"
              placeholder="逾期天数"
            >
              <template slot="append">天</template>
            </el-input>
          </el-form-item>
          <el-form-item label="最早逾期账期">
            <el-date-picker
              v-model="searchParams.fenAn"
              value-format="yyyy-MM-dd"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="fenAnChange"
            />
          </el-form-item>
          <el-form-item label="队列">
            <el-select
              v-model.trim="searchParams.workQueueId"
              placeholder="队列"
            >
              <el-option
                v-for="item in workQueueNameList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="处理人">
            <el-autocomplete
              v-model="operator"
              :fetch-suggestions="querySearch"
              placeholder="请输入处理人"
              @select="handleSelect"
              @change="operatorChange"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="联系状态">
            <el-select v-model.trim="searchParams.contactStatusCode" placeholder="联系状态">
              <el-option
                v-for="item in contactStatusList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="" @click="clear">清空</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <div class="table-section">
      <el-table
        :data="tableData"
        :header-row-style="headerRowStyle"
        max-height="550px"
        border
        highlight-current-row
        style="width: 100%"
        @cell-dblclick="dblclick"
      >
        <el-table-column prop="businessType" label="业务类型">
          <template slot-scope="scope">
            {{
              scope.row.businessType === "1"
                ? "爱分担"
                : scope.row.businessType === "2"
                ? "分担宝"
                : scope.row.businessType === "3"
                ? "助贷通道"
                : scope.row.businessType === "4"
                ? "好易付"
                : scope.row.businessType === "5"
                ? "实物租赁"
                : scope.row.businessType === "6"
                ? "乐享付"
                : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="productTypeName" label="产品" />
        <el-table-column prop="contractNumber" label="合同编号" width="200" />
        <el-table-column prop="borrowerName" label="客户姓名" />
        <el-table-column prop="overdueDate" label="逾期日期" width="100" />
        <el-table-column prop="overdueDays" label="逾期天数" />
        <el-table-column prop="amount" label="逾期金额" />
        <el-table-column prop="taskStatus" label="案件状态" />
        <el-table-column prop="contactStatusValue" label="联系状态" />
        <el-table-column prop="lastCallResult" label="最新结果" />
        <el-table-column prop="lastCallTime" label="最近跟进时间" width="100" />
        <el-table-column prop="lastCallAgent" label="处理人" width="100" />
      </el-table>
    </div>
    <div class="pagination-section">
      <el-pagination
        :page-sizes="[5, 10, 15, 20]"
        :page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next, sizes"
        @current-change="changePage"
        @size-change="sizeChange"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getSpecialTaskList } from "@/api/task.js";
import { getWorkQueueList, getDictionaryList } from "@/api/task";
import { getUser } from "@/api/manage";

export default {
  name: "mechanism",
  data() {
    return {
      headerRowStyle: {
        "background-color": "#6584b4",
      },
      tableData: [],
      pageSize: 10,
      page: 1,
      total: 0,
      searchParams: {},
      workQueueNameList: [],
      businessTypeList: [],
      productList: [],
      operator: "",
      contactStatusList: []
    };
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  async created() {
    this.getSpecialTaskList();
    const getWorkQueueListRes = await getWorkQueueList();
    getWorkQueueListRes.data.map((item) => {
      this.workQueueNameList.push({
        label: item.name,
        value: item.id,
      });
    });
    console.log(getWorkQueueListRes.data);
    const fdBusinessTypeRes = await getDictionaryList("fd_business_type");
    fdBusinessTypeRes.data.map((item) => {
      this.businessTypeList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
    const profuctRes = await getDictionaryList("product_type");
    profuctRes.data.map((item) => {
      this.productList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
    // 联系状态
    const contactStatusCodeData = await getDictionaryList('contact_status')
    contactStatusCodeData.data.map((item) => {
      this.contactStatusList.push({
        label: item.dictLabel,
        value: item.dictValue
      })
    })
  },
  methods: {
    fenAnChange(val) {
      if (val && val.length) {
        this.searchParams.overdueStartDay = val[0];
        this.searchParams.overdueEndDay = val[1];
      } else {
        this.searchParams.overdueStartDay = "";
        this.searchParams.overdueEndDay = "";
      }
    },
    async querySearch(queryString, cb) {
      const results = [];
      if (queryString) {
        const getUserRes = await getUser(queryString);
        if (getUserRes.data.length > 0) {
          getUserRes.data.map((item) => {
            results.push({
              value: item.name,
              id: item.id,
            });
          });
        }
      }
      cb(results);
    },
    handleSelect(item) {
      this.searchParams.operator = item.id;
    },
    operatorChange(val) {
      console.log(val, "val");
      if (!val) {
        this.searchParams.operator = "";
      }
    },
    /**
     * 获取列表
     */
    async getSpecialTaskList() {
      const params = {
        page: this.page,
        size: this.pageSize,
        userId: this.currentUser.id,
        workQueueName: "SPECIAL",
        ...this.searchParams,
      };
      const {
        data: { total, records },
      } = await getSpecialTaskList(params);
      this.$set(this, "tableData", records);
      this.$set(this, "total", total);
    },
    changePage(currentPage) {
      this.page = currentPage;
      this.getSpecialTaskList();
    },
    sizeChange(size) {
      this.page = 1;
      this.pageSize = size;
      this.getSpecialTaskList();
    },
    search() {
      this.page = 1;
      this.getSpecialTaskList();
    },
    clear() {
      this.searchParams = {};
      this.operator = "";
      this.getSpecialTaskList();
    },
    // 双击
    dblclick(row, column) {
      // this.$router.push({
      //   name: "taskDetail",
      //   params: { loanId: row.loanId, taskId: row.id, ...this.$route.query },
      // });
      sessionStorage.setItem('borrowerName', row.borrowerName)
      window.open(`/#/task/${row.id}/${row.loanId}/${this.$route.query.status}`, '_blank')
    },
  },
};
</script>

<style lang="scss"></style>
